export enum SimulationUpdateAction {
  TAB_SELECT = 'Tab select',
  FIELD_UPDATE = 'Field update',
  FIELD_INIT_VALUE = 'Field init value',
}
